/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApplicationApprovalResponse } from '../model';
// @ts-ignore
import { BnplOrderSortType } from '../model';
// @ts-ignore
import { ClaimProvidersResponse } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { GetOrdersList200Response } from '../model';
// @ts-ignore
import { IndividualListResponse } from '../model';
// @ts-ignore
import { OrderStatusType } from '../model';
// @ts-ignore
import { OrganizationApplicationListResponse } from '../model';
// @ts-ignore
import { OrganizationListResponse } from '../model';
// @ts-ignore
import { OrganizationRejectReasonRequest } from '../model';
// @ts-ignore
import { OrganizationResponse } from '../model';
// @ts-ignore
import { OrganizationStatus } from '../model';
// @ts-ignore
import { OrganizationUpdateDto } from '../model';
// @ts-ignore
import { SortOrderType } from '../model';
/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation approves a new organization\'s registration. The response contains a new organization\'s entity ID.
         * @summary Approves organization\'s registration
         * @param {string} id The &#x60;application_ID&#x60; of newly created organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrganizationRegistration: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveOrganizationRegistration', 'id', id)
            const localVarPath = `/v1/entity/organization/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches claim provider list that are providing custom claims for admin. `It does not contain the API requesting organization itself`.  This contains all the claim providers regardless whitelist. 
         * @summary Gets claim providers list for Admin
         * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
         * @param {number} [page] Page number. default is 1
         * @param {number} [limit] Page size. default is 50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimProviderListForAdmin: async (category?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/claim-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns a list of organizations.
         * @summary Individual users list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [entityId] 
         * @param {string} [credifyId] 
         * @param {string} [organizationId] 
         * @param {string} [phone] 
         * @param {string} [email] 
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {string} [dob] 
         * @param {'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT'} [identitySource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualUserList: async (page?: number, limit?: number, entityId?: string, credifyId?: string, organizationId?: string, phone?: string, email?: string, country?: string, postalCode?: string, dob?: string, identitySource?: 'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/individual/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (credifyId !== undefined) {
                localVarQueryParameter['credify_id'] = credifyId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }

            if (dob !== undefined) {
                localVarQueryParameter['dob'] = dob;
            }

            if (identitySource !== undefined) {
                localVarQueryParameter['identity_source'] = identitySource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns list of orders in the dashboard for admin
         * @summary Get orders list for admin
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {string} [keyword] 
         * @param {BnplOrderSortType} [sortBy] 
         * @param {SortOrderType} [sortOrder] 
         * @param {number} [month] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersListForAdmin: async (page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, month?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns a list of organization application.
         * @summary Organization applications list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {OrganizationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApplicationList: async (page?: number, limit?: number, status?: OrganizationStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns a list of organizations. 
         * @summary Organization entity list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [name] Searching organization name. It is &#x60;LIKE&#x60; query and ignore case.
         * @param {string} [id] Searching orgnaization ID.
         * @param {string} [phone] Searching phone. Example format &#x60;+84381231234&#x60; OR &#x60;84381231234&#x60; also working.
         * @param {string} [email] Searching email.
         * @param {string} [categories] Organization categories name. By using &#x60;,&#x60;, you can specify multiple categories. If it is not specified, all categories are returned.
         * @param {boolean} [oidcClient] Filtering oidc client (service provider) role. Using &#x60;oidc_client&#x3D;true&#x60; when you want to filter the organization which have oidc client rile.
         * @param {boolean} [claimProvider] Filtering claim provider (market) role. Using &#x60;claim_provider&#x3D;true&#x60; when you want to filter the organization which have claim provider rile.
         * @param {boolean} [attestor] Filtering attestor role. Using &#x60;attestor&#x3D;true&#x60; when you want to filter the organization which have attestor rile.
         * @param {boolean} [walletProxy] Filtering wallet proxy role. Using &#x60;wallet_proxy&#x3D;true&#x60; when you want to filter the organization which have wallet proxy rile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationList: async (page?: number, limit?: number, name?: string, id?: string, phone?: string, email?: string, categories?: string, oidcClient?: boolean, claimProvider?: boolean, attestor?: boolean, walletProxy?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            if (oidcClient !== undefined) {
                localVarQueryParameter['oidc_client'] = oidcClient;
            }

            if (claimProvider !== undefined) {
                localVarQueryParameter['claim_provider'] = claimProvider;
            }

            if (attestor !== undefined) {
                localVarQueryParameter['attestor'] = attestor;
            }

            if (walletProxy !== undefined) {
                localVarQueryParameter['wallet_proxy'] = walletProxy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation rejects a new organization\'s registration
         * @summary Rejects organization\'s registration
         * @param {string} id the &#x60;application_ID&#x60; of newly created organization
         * @param {OrganizationRejectReasonRequest} [organizationRejectReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationRegistration: async (id: string, organizationRejectReasonRequest?: OrganizationRejectReasonRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectOrganizationRegistration', 'id', id)
            const localVarPath = `/v1/entity/organization/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = organizationRejectReasonRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes a specified account data from Credify network by an admin user.
         * @summary Removes Organization by Admin
         * @param {string} id Entity ID specified by admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrganizationByAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeOrganizationByAdmin', 'id', id)
            const localVarPath = `/v1/entity/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation updates an organization entity in Credify network by an admin user.
         * @summary Updates Organization Info by Admin
         * @param {string} id Entity ID specified by admin
         * @param {OrganizationUpdateDto} organizationUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInfoByAdmin: async (id: string, organizationUpdateDto: OrganizationUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationInfoByAdmin', 'id', id)
            // verify required parameter 'organizationUpdateDto' is not null or undefined
            assertParamExists('updateOrganizationInfoByAdmin', 'organizationUpdateDto', organizationUpdateDto)
            const localVarPath = `/v1/entity/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = organizationUpdateDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation approves a new organization\'s registration. The response contains a new organization\'s entity ID.
         * @summary Approves organization\'s registration
         * @param {string} id The &#x60;application_ID&#x60; of newly created organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOrganizationRegistration(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationApprovalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveOrganizationRegistration(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation fetches claim provider list that are providing custom claims for admin. `It does not contain the API requesting organization itself`.  This contains all the claim providers regardless whitelist. 
         * @summary Gets claim providers list for Admin
         * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
         * @param {number} [page] Page number. default is 1
         * @param {number} [limit] Page size. default is 50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimProviderListForAdmin(category?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProvidersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimProviderListForAdmin(category, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns a list of organizations.
         * @summary Individual users list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [entityId] 
         * @param {string} [credifyId] 
         * @param {string} [organizationId] 
         * @param {string} [phone] 
         * @param {string} [email] 
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {string} [dob] 
         * @param {'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT'} [identitySource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualUserList(page?: number, limit?: number, entityId?: string, credifyId?: string, organizationId?: string, phone?: string, email?: string, country?: string, postalCode?: string, dob?: string, identitySource?: 'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualUserList(page, limit, entityId, credifyId, organizationId, phone, email, country, postalCode, dob, identitySource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns list of orders in the dashboard for admin
         * @summary Get orders list for admin
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {string} [keyword] 
         * @param {BnplOrderSortType} [sortBy] 
         * @param {SortOrderType} [sortOrder] 
         * @param {number} [month] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersListForAdmin(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, month?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrdersList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersListForAdmin(page, limit, statuses, keyword, sortBy, sortOrder, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns a list of organization application.
         * @summary Organization applications list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {OrganizationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationApplicationList(page?: number, limit?: number, status?: OrganizationStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationApplicationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationApplicationList(page, limit, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns a list of organizations. 
         * @summary Organization entity list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [name] Searching organization name. It is &#x60;LIKE&#x60; query and ignore case.
         * @param {string} [id] Searching orgnaization ID.
         * @param {string} [phone] Searching phone. Example format &#x60;+84381231234&#x60; OR &#x60;84381231234&#x60; also working.
         * @param {string} [email] Searching email.
         * @param {string} [categories] Organization categories name. By using &#x60;,&#x60;, you can specify multiple categories. If it is not specified, all categories are returned.
         * @param {boolean} [oidcClient] Filtering oidc client (service provider) role. Using &#x60;oidc_client&#x3D;true&#x60; when you want to filter the organization which have oidc client rile.
         * @param {boolean} [claimProvider] Filtering claim provider (market) role. Using &#x60;claim_provider&#x3D;true&#x60; when you want to filter the organization which have claim provider rile.
         * @param {boolean} [attestor] Filtering attestor role. Using &#x60;attestor&#x3D;true&#x60; when you want to filter the organization which have attestor rile.
         * @param {boolean} [walletProxy] Filtering wallet proxy role. Using &#x60;wallet_proxy&#x3D;true&#x60; when you want to filter the organization which have wallet proxy rile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationList(page?: number, limit?: number, name?: string, id?: string, phone?: string, email?: string, categories?: string, oidcClient?: boolean, claimProvider?: boolean, attestor?: boolean, walletProxy?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationList(page, limit, name, id, phone, email, categories, oidcClient, claimProvider, attestor, walletProxy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation rejects a new organization\'s registration
         * @summary Rejects organization\'s registration
         * @param {string} id the &#x60;application_ID&#x60; of newly created organization
         * @param {OrganizationRejectReasonRequest} [organizationRejectReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectOrganizationRegistration(id: string, organizationRejectReasonRequest?: OrganizationRejectReasonRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectOrganizationRegistration(id, organizationRejectReasonRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation deletes a specified account data from Credify network by an admin user.
         * @summary Removes Organization by Admin
         * @param {string} id Entity ID specified by admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOrganizationByAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeOrganizationByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation updates an organization entity in Credify network by an admin user.
         * @summary Updates Organization Info by Admin
         * @param {string} id Entity ID specified by admin
         * @param {OrganizationUpdateDto} organizationUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationInfoByAdmin(id: string, organizationUpdateDto: OrganizationUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationInfoByAdmin(id, organizationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * This operation approves a new organization\'s registration. The response contains a new organization\'s entity ID.
         * @summary Approves organization\'s registration
         * @param {string} id The &#x60;application_ID&#x60; of newly created organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrganizationRegistration(id: string, options?: any): AxiosPromise<ApplicationApprovalResponse> {
            return localVarFp.approveOrganizationRegistration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches claim provider list that are providing custom claims for admin. `It does not contain the API requesting organization itself`.  This contains all the claim providers regardless whitelist. 
         * @summary Gets claim providers list for Admin
         * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
         * @param {number} [page] Page number. default is 1
         * @param {number} [limit] Page size. default is 50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimProviderListForAdmin(category?: string, page?: number, limit?: number, options?: any): AxiosPromise<ClaimProvidersResponse> {
            return localVarFp.getClaimProviderListForAdmin(category, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns a list of organizations.
         * @summary Individual users list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [entityId] 
         * @param {string} [credifyId] 
         * @param {string} [organizationId] 
         * @param {string} [phone] 
         * @param {string} [email] 
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {string} [dob] 
         * @param {'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT'} [identitySource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualUserList(page?: number, limit?: number, entityId?: string, credifyId?: string, organizationId?: string, phone?: string, email?: string, country?: string, postalCode?: string, dob?: string, identitySource?: 'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT', options?: any): AxiosPromise<IndividualListResponse> {
            return localVarFp.getIndividualUserList(page, limit, entityId, credifyId, organizationId, phone, email, country, postalCode, dob, identitySource, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns list of orders in the dashboard for admin
         * @summary Get orders list for admin
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {string} [keyword] 
         * @param {BnplOrderSortType} [sortBy] 
         * @param {SortOrderType} [sortOrder] 
         * @param {number} [month] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersListForAdmin(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, month?: number, year?: number, options?: any): AxiosPromise<GetOrdersList200Response> {
            return localVarFp.getOrdersListForAdmin(page, limit, statuses, keyword, sortBy, sortOrder, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns a list of organization application.
         * @summary Organization applications list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {OrganizationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApplicationList(page?: number, limit?: number, status?: OrganizationStatus, options?: any): AxiosPromise<OrganizationApplicationListResponse> {
            return localVarFp.getOrganizationApplicationList(page, limit, status, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns a list of organizations. 
         * @summary Organization entity list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [name] Searching organization name. It is &#x60;LIKE&#x60; query and ignore case.
         * @param {string} [id] Searching orgnaization ID.
         * @param {string} [phone] Searching phone. Example format &#x60;+84381231234&#x60; OR &#x60;84381231234&#x60; also working.
         * @param {string} [email] Searching email.
         * @param {string} [categories] Organization categories name. By using &#x60;,&#x60;, you can specify multiple categories. If it is not specified, all categories are returned.
         * @param {boolean} [oidcClient] Filtering oidc client (service provider) role. Using &#x60;oidc_client&#x3D;true&#x60; when you want to filter the organization which have oidc client rile.
         * @param {boolean} [claimProvider] Filtering claim provider (market) role. Using &#x60;claim_provider&#x3D;true&#x60; when you want to filter the organization which have claim provider rile.
         * @param {boolean} [attestor] Filtering attestor role. Using &#x60;attestor&#x3D;true&#x60; when you want to filter the organization which have attestor rile.
         * @param {boolean} [walletProxy] Filtering wallet proxy role. Using &#x60;wallet_proxy&#x3D;true&#x60; when you want to filter the organization which have wallet proxy rile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationList(page?: number, limit?: number, name?: string, id?: string, phone?: string, email?: string, categories?: string, oidcClient?: boolean, claimProvider?: boolean, attestor?: boolean, walletProxy?: boolean, options?: any): AxiosPromise<OrganizationListResponse> {
            return localVarFp.getOrganizationList(page, limit, name, id, phone, email, categories, oidcClient, claimProvider, attestor, walletProxy, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation rejects a new organization\'s registration
         * @summary Rejects organization\'s registration
         * @param {string} id the &#x60;application_ID&#x60; of newly created organization
         * @param {OrganizationRejectReasonRequest} [organizationRejectReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationRegistration(id: string, organizationRejectReasonRequest?: OrganizationRejectReasonRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.rejectOrganizationRegistration(id, organizationRejectReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes a specified account data from Credify network by an admin user.
         * @summary Removes Organization by Admin
         * @param {string} id Entity ID specified by admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrganizationByAdmin(id: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.removeOrganizationByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation updates an organization entity in Credify network by an admin user.
         * @summary Updates Organization Info by Admin
         * @param {string} id Entity ID specified by admin
         * @param {OrganizationUpdateDto} organizationUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInfoByAdmin(id: string, organizationUpdateDto: OrganizationUpdateDto, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.updateOrganizationInfoByAdmin(id, organizationUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - interface
 * @export
 * @interface AdminApi
 */
export interface AdminApiInterface {
    /**
     * This operation approves a new organization\'s registration. The response contains a new organization\'s entity ID.
     * @summary Approves organization\'s registration
     * @param {string} id The &#x60;application_ID&#x60; of newly created organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    approveOrganizationRegistration(id: string, options?: AxiosRequestConfig): AxiosPromise<ApplicationApprovalResponse>;

    /**
     * This operation fetches claim provider list that are providing custom claims for admin. `It does not contain the API requesting organization itself`.  This contains all the claim providers regardless whitelist. 
     * @summary Gets claim providers list for Admin
     * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
     * @param {number} [page] Page number. default is 1
     * @param {number} [limit] Page size. default is 50
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getClaimProviderListForAdmin(category?: string, page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<ClaimProvidersResponse>;

    /**
     * This returns a list of organizations.
     * @summary Individual users list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [entityId] 
     * @param {string} [credifyId] 
     * @param {string} [organizationId] 
     * @param {string} [phone] 
     * @param {string} [email] 
     * @param {string} [country] 
     * @param {string} [postalCode] 
     * @param {string} [dob] 
     * @param {'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT'} [identitySource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getIndividualUserList(page?: number, limit?: number, entityId?: string, credifyId?: string, organizationId?: string, phone?: string, email?: string, country?: string, postalCode?: string, dob?: string, identitySource?: 'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT', options?: AxiosRequestConfig): AxiosPromise<IndividualListResponse>;

    /**
     * This returns list of orders in the dashboard for admin
     * @summary Get orders list for admin
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {string} [keyword] 
     * @param {BnplOrderSortType} [sortBy] 
     * @param {SortOrderType} [sortOrder] 
     * @param {number} [month] 
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getOrdersListForAdmin(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, month?: number, year?: number, options?: AxiosRequestConfig): AxiosPromise<GetOrdersList200Response>;

    /**
     * This returns a list of organization application.
     * @summary Organization applications list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {OrganizationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getOrganizationApplicationList(page?: number, limit?: number, status?: OrganizationStatus, options?: AxiosRequestConfig): AxiosPromise<OrganizationApplicationListResponse>;

    /**
     * This returns a list of organizations. 
     * @summary Organization entity list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [name] Searching organization name. It is &#x60;LIKE&#x60; query and ignore case.
     * @param {string} [id] Searching orgnaization ID.
     * @param {string} [phone] Searching phone. Example format &#x60;+84381231234&#x60; OR &#x60;84381231234&#x60; also working.
     * @param {string} [email] Searching email.
     * @param {string} [categories] Organization categories name. By using &#x60;,&#x60;, you can specify multiple categories. If it is not specified, all categories are returned.
     * @param {boolean} [oidcClient] Filtering oidc client (service provider) role. Using &#x60;oidc_client&#x3D;true&#x60; when you want to filter the organization which have oidc client rile.
     * @param {boolean} [claimProvider] Filtering claim provider (market) role. Using &#x60;claim_provider&#x3D;true&#x60; when you want to filter the organization which have claim provider rile.
     * @param {boolean} [attestor] Filtering attestor role. Using &#x60;attestor&#x3D;true&#x60; when you want to filter the organization which have attestor rile.
     * @param {boolean} [walletProxy] Filtering wallet proxy role. Using &#x60;wallet_proxy&#x3D;true&#x60; when you want to filter the organization which have wallet proxy rile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getOrganizationList(page?: number, limit?: number, name?: string, id?: string, phone?: string, email?: string, categories?: string, oidcClient?: boolean, claimProvider?: boolean, attestor?: boolean, walletProxy?: boolean, options?: AxiosRequestConfig): AxiosPromise<OrganizationListResponse>;

    /**
     * This operation rejects a new organization\'s registration
     * @summary Rejects organization\'s registration
     * @param {string} id the &#x60;application_ID&#x60; of newly created organization
     * @param {OrganizationRejectReasonRequest} [organizationRejectReasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    rejectOrganizationRegistration(id: string, organizationRejectReasonRequest?: OrganizationRejectReasonRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation deletes a specified account data from Credify network by an admin user.
     * @summary Removes Organization by Admin
     * @param {string} id Entity ID specified by admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    removeOrganizationByAdmin(id: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation updates an organization entity in Credify network by an admin user.
     * @summary Updates Organization Info by Admin
     * @param {string} id Entity ID specified by admin
     * @param {OrganizationUpdateDto} organizationUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    updateOrganizationInfoByAdmin(id: string, organizationUpdateDto: OrganizationUpdateDto, options?: AxiosRequestConfig): AxiosPromise<OrganizationResponse>;

}

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI implements AdminApiInterface {
    /**
     * This operation approves a new organization\'s registration. The response contains a new organization\'s entity ID.
     * @summary Approves organization\'s registration
     * @param {string} id The &#x60;application_ID&#x60; of newly created organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public approveOrganizationRegistration(id: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).approveOrganizationRegistration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches claim provider list that are providing custom claims for admin. `It does not contain the API requesting organization itself`.  This contains all the claim providers regardless whitelist. 
     * @summary Gets claim providers list for Admin
     * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
     * @param {number} [page] Page number. default is 1
     * @param {number} [limit] Page size. default is 50
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getClaimProviderListForAdmin(category?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).getClaimProviderListForAdmin(category, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns a list of organizations.
     * @summary Individual users list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [entityId] 
     * @param {string} [credifyId] 
     * @param {string} [organizationId] 
     * @param {string} [phone] 
     * @param {string} [email] 
     * @param {string} [country] 
     * @param {string} [postalCode] 
     * @param {string} [dob] 
     * @param {'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT'} [identitySource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getIndividualUserList(page?: number, limit?: number, entityId?: string, credifyId?: string, organizationId?: string, phone?: string, email?: string, country?: string, postalCode?: string, dob?: string, identitySource?: 'CREDIFY_INDIVIDUAL' | 'CREDIFY_ORGANIZATION' | 'FACEBOOK' | 'LINKEDIN' | 'LINE' | 'VOTER_IDENTITY' | 'DRIVER_LICENCE' | 'NATIONAL_IDENTITY_CARD' | 'TAX_IDENTITY' | 'BIOMETRIC_RESIDENCE_PERMIT', options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).getIndividualUserList(page, limit, entityId, credifyId, organizationId, phone, email, country, postalCode, dob, identitySource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns list of orders in the dashboard for admin
     * @summary Get orders list for admin
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {string} [keyword] 
     * @param {BnplOrderSortType} [sortBy] 
     * @param {SortOrderType} [sortOrder] 
     * @param {number} [month] 
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getOrdersListForAdmin(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, month?: number, year?: number, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).getOrdersListForAdmin(page, limit, statuses, keyword, sortBy, sortOrder, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns a list of organization application.
     * @summary Organization applications list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {OrganizationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getOrganizationApplicationList(page?: number, limit?: number, status?: OrganizationStatus, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).getOrganizationApplicationList(page, limit, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns a list of organizations. 
     * @summary Organization entity list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [name] Searching organization name. It is &#x60;LIKE&#x60; query and ignore case.
     * @param {string} [id] Searching orgnaization ID.
     * @param {string} [phone] Searching phone. Example format &#x60;+84381231234&#x60; OR &#x60;84381231234&#x60; also working.
     * @param {string} [email] Searching email.
     * @param {string} [categories] Organization categories name. By using &#x60;,&#x60;, you can specify multiple categories. If it is not specified, all categories are returned.
     * @param {boolean} [oidcClient] Filtering oidc client (service provider) role. Using &#x60;oidc_client&#x3D;true&#x60; when you want to filter the organization which have oidc client rile.
     * @param {boolean} [claimProvider] Filtering claim provider (market) role. Using &#x60;claim_provider&#x3D;true&#x60; when you want to filter the organization which have claim provider rile.
     * @param {boolean} [attestor] Filtering attestor role. Using &#x60;attestor&#x3D;true&#x60; when you want to filter the organization which have attestor rile.
     * @param {boolean} [walletProxy] Filtering wallet proxy role. Using &#x60;wallet_proxy&#x3D;true&#x60; when you want to filter the organization which have wallet proxy rile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getOrganizationList(page?: number, limit?: number, name?: string, id?: string, phone?: string, email?: string, categories?: string, oidcClient?: boolean, claimProvider?: boolean, attestor?: boolean, walletProxy?: boolean, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).getOrganizationList(page, limit, name, id, phone, email, categories, oidcClient, claimProvider, attestor, walletProxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation rejects a new organization\'s registration
     * @summary Rejects organization\'s registration
     * @param {string} id the &#x60;application_ID&#x60; of newly created organization
     * @param {OrganizationRejectReasonRequest} [organizationRejectReasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public rejectOrganizationRegistration(id: string, organizationRejectReasonRequest?: OrganizationRejectReasonRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).rejectOrganizationRegistration(id, organizationRejectReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes a specified account data from Credify network by an admin user.
     * @summary Removes Organization by Admin
     * @param {string} id Entity ID specified by admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public removeOrganizationByAdmin(id: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).removeOrganizationByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation updates an organization entity in Credify network by an admin user.
     * @summary Updates Organization Info by Admin
     * @param {string} id Entity ID specified by admin
     * @param {OrganizationUpdateDto} organizationUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public updateOrganizationInfoByAdmin(id: string, organizationUpdateDto: OrganizationUpdateDto, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).updateOrganizationInfoByAdmin(id, organizationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}
